import React, { PropTypes, Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../actions";

import DataProvider from "../dataProvider";

import {
  NitroLoading,
  NitroDrawer,
  NitroContentNotAvailable,
  NitroButton
} from "nitro-components";

import { isEmpty, cloneDeep } from "lodash";

import ComponentFactory from "../../../components/utils/ComponentFactory.js";

import Breakpoint from "../../../utils/breakpoints";

class DetailsSidePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileVersion: false,
      actionItems: {},
      showFooterActions: false
    };
    this.gerenateActionButtons = this.gerenateActionButtons.bind(this);
    this.callToAction = this.callToAction.bind(this);
  }

  arrayContains = (value, array) => {
    let found;
    for (let i = 0; i < array.length && !found; i++) {
      if (array[i] === value) {
        found = true;
        break;
      }
    }
    return found;
  };

  gerenateActionButtons = details => {
    if (!details) return null;
    let obj = null;
    const isMobile = false;

    const componenentDetails = cloneDeep(details);

    let callToAction = componenentDetails.Component;
    if (callToAction && callToAction.length > 0) {
      obj = { left: [], right: [] };
      let doubleDashboards = false;
      const componentTypes = callToAction.map((item, index) => {
        return item.componentType;
      });

      if (
        this.arrayContains("driverProfile", componentTypes) &&
        this.arrayContains("vehicleProfile", componentTypes)
      ) {
        doubleDashboards = true;
      }
      callToAction.forEach(item => {
        item.action = () => this.callToAction(item);
        switch (item.componentType) {
          case "mobile":
            item.label = isMobile ? `Call` : `Call ${item.detail}`;

            obj.left.push(item);
            break;
          case "email":
            item.label = `Email`;
            obj.left.push(item);
            break;
          case "driverProfile":
            item.label = isMobile && !doubleDashboards
              ? `Profile `
              : "Driver Profile";
            item.variant = doubleDashboards ? "" : "secondary";
            doubleDashboards ? obj.left.push(item) : obj.right.push(item);
            break;
          case "vehicleProfile":
            item.label = isMobile && !doubleDashboards
              ? `Profile`
              : "Vehicle Profile";
            item.variant = "secondary";
            obj.right.push(item);
            break;
          default:
            return null;
        }
      });
    }

    return obj;
  };

  callToAction = item => {
    switch (item.componentType) {
      case "mobile":
        window.location = `tel:${item.detail.replace(/\s/g, "")}`;
        break;
      case "email":
        window.location = `mailto:${item.detail}`;
        break;
      case "driverProfile":
        window.open(`${item.detail}`, "_blank");
        break;
      case "vehicleProfile":
        window.open(`${item.detail}`, "_blank");
        break;
      default:
    }
  };

  close = () => {
    this.setState({ actionItems: {} });
    this.props.close();
  };

  render() {
    // const item = this.getFooterActionItems;
    // inject side panel hader with default graph title if server doesn't
    // provide navigation header
    let sidePanelDetailsWithHeader = {};
    let SidePanContents = [];
    let actionObjs = {};
    if (this.props.detail && !this.props.fetchingDetail) {
      sidePanelDetailsWithHeader = this.props.detail.filter(
        d => d["@DisplayType"] === "navigation-header"
      ).length === 1
        ? this.props.detail
        : [
            { "@DisplayType": "navigation-header", Title: this.props.title },
            ...this.props.detail
          ];

      SidePanContents =
        this.props.detail &&
        this.props.detail.length > 0 &&
        sidePanelDetailsWithHeader.map(
          (
            {
              Columns,
              Rows,
              Header,
              Title,
              Footers,
              Data,
              FetchParams,
              HeaderPostFix,
              ActionDetails,
              ...component
            },
            idx
          ) => {
            return (
              <ComponentFactory
                key={idx}
                {...{
                  Columns,
                  Rows,
                  Header,
                  Title,
                  Footers,
                  Data,
                  title: this.props.title,
                  navTitle: this.props.navTitle,
                  FetchParams,
                  HeaderPostFix,
                  ActionDetails,
                  ...component
                }}
              />
            );
          }
        );
      const actioncalls = this.props.detail.filter(function(graph) {
        return graph["@DisplayType"] === "callToAction";
      });

      const action = actioncalls[0];
      actionObjs = this.gerenateActionButtons(action);
    }

    return (
      <section>

        <NitroDrawer
          isOpen={this.props.open}
          close={this.close}
          width={450}
          padding="20px"
          actions={this.state.actionItems}
          labelVariant="secondary"
          actions={actionObjs}
          staticFooter={!isEmpty(actionObjs)}
          iconVariant="white"
          closeIconSize={14}
        >

          {!this.props.fetchingDetail && SidePanContents}
          {this.props.fetchingDetail && <NitroLoading />}
          {(this.props.dataError ||
            (this.props.detail && !this.props.detail.length)) &&
            !this.props.fetchingDetail &&
            <NitroContentNotAvailable />}

        </NitroDrawer>
      </section>
    );
  }
}

DetailsSidePanel.propTypes = {
  action: PropTypes.shape({}),
  detail: PropTypes.array,
  fetchingDetail: PropTypes.bool,
  open: PropTypes.bool,
  close: PropTypes.func,
  title: PropTypes.string
};

DetailsSidePanel.defaultProps = {};

export default DataProvider(DetailsSidePanel);



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/DetailsSidePanel.js